

export const UserBookCreateMaxGuide = ({ summary }) => {

    return (
        <div className="userBookCreate">
            <div className="step inner guideStep">
                <div className="row">
                    <div className="col12 col-md-12">
                        <div className="guideBox">
                            <h3 className="title">연재 작품수 (10개)를 초과 했습니다.</h3>
                            <ol>
                                <li>동시 연재는 <span>작품 10개</span>까지 가능합니다.</li>
                                <li>연재가 완료된 작품은 <span>완결</span> 해주세요.</li>
                                <li>작품만 만들고 글을 쓰지 않는 작품은 <span>삭제</span>해주세요.</li>
                                <li>작품의 <span>2회차</span>부터 <span>완결</span>할 수 있어요.</li>
                            </ol>
                        </div>

                        <div className="bookSummary">
                            <span className='separate'>연재중인 작품: <strong>{summary?.total - summary?.complete || 0}</strong></span>
                            <span>완결된 작품: <strong>{summary?.complete || 0}</strong></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
